var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{class:_vm.classList},[_vm._t("default",function(){return [_vm._v("NZS Admin "),_c('router-link',{staticClass:"card-link",attrs:{"to":{ name: 'ChangeLogList' }}},[_vm._v("v"+_vm._s(_vm.$store.getters.appVersion))]),_vm._v(" (© "+_vm._s(new Date().getFullYear())+" N Zone Sports of America)")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }